module.exports = __webpack_public_path__ + "img/hero.05f6b654.png";